import IconTextArrowCard from 'widgets/cards/iconTextArrow';
import * as Styles from './styles';
import { getDomainOrigin } from 'utils/serverConfig';

function NewPlan() {
    const onClickNewPlan = () => {
        window.location.href = `${getDomainOrigin()}/auto-partnership-buy/mpos/dealer/pre-quote?current_node=enter_mmv_details_node`;
    };

    return (
        <Styles.NewPlanWrapper>
            <IconTextArrowCard
                icon={'/icons/claim.svg'}
                text={'Create new plan'}
                backgroundColor={'161.3deg, #FFF7E5 -2.04%, #FBE9F6 102.81%'}
                onClick={onClickNewPlan}
            />
        </Styles.NewPlanWrapper>
    );
}

export default NewPlan;
